import { useSyncExternalStore } from 'react';
import axios from 'axios';

type Listener = () => void;

const FAILURE_THRESHOLD = 2;
const SERVER_DOWN_STATUSES = new Set([502, 503, 504]);

let consecutiveFailures = 0;
let degraded = false;
const listeners = new Set<Listener>();

const setDegraded = (next: boolean) => {
  if (next === degraded) return;
  degraded = next;
  listeners.forEach((listener) => listener());
};

export const reportApiSuccess = () => {
  consecutiveFailures = 0;
  setDegraded(false);
};

/** Only connectivity-level failures count; 4xx and ordinary 500s mean the server is reachable. */
export const reportApiError = (error: any) => {
  if (axios.isCancel(error) || error?.code === 'ERR_CANCELED') return;
  const status = error?.response?.status;
  if (status && !SERVER_DOWN_STATUSES.has(status)) {
    reportApiSuccess();
    return;
  }
  consecutiveFailures += 1;
  if (consecutiveFailures >= FAILURE_THRESHOLD) setDegraded(true);
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => degraded;

export const useApiDegraded = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
